// eslint-disable-next-line import/no-anonymous-default-export

/*
type: 0 users
type: 1 expenses

*/
const requests = [
    //!users
    {
        "id": 0,
        label: 'deleteTheLastSubscriptionAndExpireIt',
        requestType: 0
    }, {
        "id": 1,
        label: 'problemsWithTheParticipantsBalance',
        requestType: 0
    }, {
        "id": 2,
        label: 'problemsWithFaceRecognition',
        requestType: 0
    }, {
        "id": 3,
        label: 'lastSubscriptionNotIncludedInDailyReport',
        requestType: 0
    }, {
        "id": 4,
        label: 'problemsWithMobileAccounts',
        requestType: 0
    }, {
        "id": 5,
        label: 'theSameMemberHasMultipleAccounts',
        requestType: 0
    }, {
        "id": 6,
        label: 'transferOfParticipation',
        requestType: 0
    },
    //!course
    {
        "id": 7,
        label: 'changeTrainerName',
        requestType: 1
    },
    {
        "id": 8,
        label: 'changeCoursePrice',
        requestType: 1
    },
    {
        "id": 9,
        label: 'deleteCourse',
        requestType: 1
    },
    //!expense
    {
        "id": 10,
        label: 'deleteExpense',
        requestType: 2
    },
    //!supplements
    {
        "id": 11,
        label: 'changeSupplementPrice',
        requestType: 3
    },
    //!orders
    {
        "id": 12,
        label: 'deleteRevenue',
        requestType: 4
    },
]

const requestSuggestions = (requestType) => {
    return requests.filter((a) => a.requestType === requestType)
}

export default requestSuggestions;